export const carColours = [
  'Black',
  'Blue',
  'Grey',
  'White',
  'Silver',
  'Red',
  'Green',
  'Beige',
  'Bronze',
  'Brown',
  'Gold',
  'Multicolour',
  'Orange',
  'Pink',
  'Purple',
  'Yellow',
];
